import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { mk } from "../../lib/market";

export function CartButton() {
  const [n, setN] = useState(0);
  useEffect(() => {
    const load = () => mk.get("/market/cart").then((r) => setN(r.data.count)).catch(() => {});
    load();
    window.addEventListener("lif-cart", load);
    return () => window.removeEventListener("lif-cart", load);
  }, []);
  return (
    <Link to="/market/cart" className="btn-outline-gold !py-2.5 whitespace-nowrap relative" data-testid="market-cart-link">
      <ShoppingBag className="w-4 h-4" /> Cart
      {n > 0 && <span className="absolute -top-1.5 -right-1.5 min-w-5 h-5 px-1 rounded-full bg-[var(--gold)] text-white text-[10px] flex items-center justify-center" data-testid="market-cart-count">{n}</span>}
    </Link>
  );
}
